import React from 'react';
import { useParams } from 'react-router';
import { useQuestionnaire } from './hooks/useQuestionnaire';
import QuestionnaireViewerEditor from './components/QuestionnaireViewerEditor/QuestionnaireViewerEditor';
import { Loading } from '../../../healtheraComponents';

const QuestionnairePage = () => {
  const { questionnaireId } = useParams<{ questionnaireId: string }>();

  const { questionnaire, isLoading, refetch } = useQuestionnaire(questionnaireId);

  if (isLoading) return <Loading />;
  if (!questionnaire) return <div>Questionnaire not found</div>;

  return <QuestionnaireViewerEditor questionnaire={questionnaire} refetchQuestionnaire={refetch} />;
};

export default QuestionnairePage;
